module.exports = __webpack_public_path__ + "media/images/new_home/mobile-mission-bg-effa97ef54748fd1b97e5943794f4c28.svg";